import axios from 'axios';
import {HwImage, TreeViewNode, UploadedFile} from './interfaces/models';
import {
    ApiResponse,
    ApiResponseData,
    ApiResponsePaged,
    ImageFilterRequestDto,
    ImageFilterResponseDto,
    SaveImageDataDto,
    UploadReplacementImageDto, UserDto
} from './interfaces/dto';

const dataControllerPath = '/api/data/';
const uploadsControllerPath = '/api/uploads/';
const usersControllerPath = '/api/users';

export interface GetPagedParams {
    page?: number,
    pageSize?: number
}

export interface GetImagesParams extends GetPagedParams {
    filterId: string,
    filterReviewedAfter: number
}

export interface GetUploadedFilesParams extends GetPagedParams { }


export async function getFilterTree(
    authToken: string, 
    reload: boolean = false
): Promise<ApiResponseData<TreeViewNode[]>> {
    const path = dataControllerPath + 'filter-tree';
    const config = createConfig(authToken, {reload});
    try {
        const response = await axios.get<ApiResponseData<TreeViewNode[]>>(path, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function getFilterId(
    authToken: string, 
    materialPaths: string[]
): Promise<ApiResponseData<ImageFilterResponseDto>> {
    const path = dataControllerPath + 'filter-id';
    const requestData: ImageFilterRequestDto = {
        materialPaths
    };
    try {
        const response = await axios.post<ApiResponseData<ImageFilterResponseDto>>(path, requestData, createConfig(authToken));
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function getImages(
    authToken: string,
    params: GetImagesParams
): Promise<ApiResponsePaged<HwImage>> {
    const path = dataControllerPath + 'images';
    const config = createConfig(authToken, params);
    try {
        const response = await axios.get<ApiResponsePaged<HwImage>>(path, config);
        return response.data;
    } catch (err) {
        // todo: redirect to select screen on 404
        // todo: handle errors, display messages
        throw err;
    }
}

export async function saveImage(authToken: string, data: SaveImageDataDto): Promise<ApiResponse> {
    const path = dataControllerPath + 'save-image';
    const config = createConfig(authToken);
    try {
        const response = await axios.post<ApiResponse>(path, data, config);
        return response.data;
    } catch(err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function getUploadedFiles(authToken: string, params: GetUploadedFilesParams): Promise<ApiResponsePaged<UploadedFile>> {
    const path = uploadsControllerPath + 'uploaded-files';
    const config = createConfig(authToken, params);
    try {
        const response = await axios.get<ApiResponsePaged<UploadedFile>>(path, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function getUsers(authToken: string): Promise<ApiResponseData<UserDto[]>> {
    const config = createConfig(authToken);
    try {
        const response = await axios.get<ApiResponseData<UserDto[]>>(usersControllerPath, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function addOrUpdateUser(authToken: string, data: UserDto): Promise<ApiResponse> {
    const config = createConfig(authToken);
    try {
        const response = await axios.post<ApiResponse>(usersControllerPath, data, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function uploadFiles(authToken: string, files: FileList) : Promise<ApiResponse> {
    const path = uploadsControllerPath + 'upload';
    const config = {
        headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'multipart/form-data'
        }
    };

    const formData = new FormData();
    Array.from(files).forEach((file) => {
        formData.append('files', file, file.name)
    });
    
    try {
        const response = await axios.post<ApiResponse>(path, formData, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

export async function uploadImageReplacement(authToken: string, dto: UploadReplacementImageDto) : Promise<ApiResponse> {
    const path = uploadsControllerPath + 'upload-replace';
    const config = {
        headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'multipart/form-data'
        }
    };

    const formData = new FormData();
    formData.append('HwImageId', dto.hwImageId);
    formData.append('File', dto.file, dto.file.name);
    dto.activityIds.forEach((id, i) => {
        formData.append(`ActivityIds[${i}]`, id);
    });

    try {
        const response = await axios.post<ApiResponse>(path, formData, config);
        return response.data;
    } catch (err) {
        // todo: handle errors, display messages
        throw err;
    }
}

const createConfig = (authToken: string, params?: any) => ({
    headers: {
        Authorization: `Bearer ${authToken}`
    },
    params
});